import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Headline.css';

const propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['medium', 'large', 'small']),
    isDark: PropTypes.bool,
};

export class Headline extends React.Component {
    static defaultProps = {
        size: 'medium',
        isDark: false,
    };

    render() {
        const { size, className, isDark, ...headlineProps } = this.props;

        return React.createElement(
            this.props.size === 'medium'
                ? 'h3'
                : this.props.size === 'large'
                    ? 'h1'
                    : this.props.size === 'small'
                        ? 'h5'
                        : 'h3',
            {
                className: classNames(s.headline, s[size], { [s.dark]: isDark }, className),
                ...headlineProps,
            },
            this.props.children
        );
    }
}

Headline.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/text/Headline.jsx